import DividerWithText from "../../../../../components/DividerWithText";
import React from "react";
import {useTranslation} from "react-i18next";
import CustomDateTimePicker from "../../../../../components/CustomDateTimePicker";
import {Box, MenuItem} from "@mui/material";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {useSelector} from "react-redux";
import {CustomTextField} from "../../../../../components/CustomTextField";
import CustomSelectViewCard from "../../../../../components/CustomSelectViewCard";
import NotInformation from "../../../../../components/NotInformation";
import {permissionObj} from "../../../../../Helpers/permission";
import {DEFAULT_VISITOR_TYPE, NONE_VISITOR_TYPE, getVisitorTypeName} from "../../Type/Model/Model";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL, USER_TYPE_NAME_MODEL} from "../../../../../enums/userTypeEnum";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";
import {CustomSwitch} from "../../../../../components/CustomSwitch";
import {MIN_MAX} from "../../../../../enums/MinMaxEnum";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const CreateVisitorInvitationForm = ({ handleChange, disabled, item, emptyFields, selectedList, setSelectedList,
                                         setSelectedHost, selectedHost, setAddShow,defaultTolerance,
                                         setModified, requestAccessId, isValidStartDate, isValidEndDate }) => {
    const { t } = useTranslation();
    const { employeeWorkStations } = useSelector((state) => state.CompanyEmployeesSlice);
    const getAllVisitorTypes = useSelector((state) => state?.EmployeeEventsSlice?.getAllVisitorTypes);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission, user } = useSelector((state) => state.authenticatioauthennSlice);
    // A guard carries no permissions, its user type registers visitors
    const isGuard = user?.data?.userType?.name === USER_TYPE_NAME_MODEL.GUARD;
    const minEndDate = item?.startDate ? new Date(new Date(item.startDate).getTime() + 30 * 60 * 1000) : null;

    const val = item?.accessToleranceMin;
    const isDefault = !item?.isValidTolerance() && Number(val) === Number(defaultTolerance);
    const isRequiredError = emptyFields && item.isValidTolerance();
    const accessToleranceHelperText =
        isRequiredError ? t('requiredField') :
            item?.isValidTolerance() ? t('it_must_be_greater_than_or_equal_to', { min: MIN_MAX.ACCESS_TOLERANCE.start }) :
                isDefault ? t('inherited_from_system_settings') : '';

    return (
        <>
            <Box className='row'>
                <div className={'col-12 mb-4 mt-4'}>
                    <DividerWithText title={t('data')} />
                </div>

                <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomDateTimePicker
                        id={'dp_cvif_start_date'}
                        name={'startDate'}
                        disabled={disabled}
                        onChange={(e)=>{
                            handleChange({ target: { value: e, name: 'startDate' } });
                        }}
                        trans={'start_date_at_time'}
                        value={item?.startDate}
                        required={true}
                        disablePast={true}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        maxDate={item.endDate ? new Date(item.endDate) : undefined}
                        isValid={isValidStartDate}
                        isValidText={'start_date_must_be_in_the_future'}
                    />
                </Box>
                <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomDateTimePicker
                        id={'dp_cvif_end_date'}
                        name={'endDate'}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'endDate' } });
                        }}
                        disabled={!item?.startDate}
                        trans={'end_date_at_time'}
                        value={item?.endDate}
                        required={true}
                        disablePast={true}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        minDateTime={minEndDate}
                        isValid={isValidEndDate}
                        isValidText={'end_date_must_be_30min_later'}
                    />
                </Box>
                <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomTextField id={"txt_cvif_visitor_number"}
                                     length={2}
                                     name={"visitorNumber"}
                                     type={'number'}
                                     placeholder={t("placeholder_guest_count")}
                                     value={item.visitorNumber}
                                     trans={"guest_count"}
                                     onChange={(evt) => {handleChange(evt, "visitorNumber")}}
                    />
                </Box>
                <Box className='col-12 col-md-6'>
                    <CustomTextField id={"txt_cvif_access_tolerance"}
                                     length={2}
                                     name={"accessToleranceMin"}
                                     type={'number'}
                                     required
                                     emptyFields={emptyFields}
                                     isValid={!isRequiredError}
                                     helperText={accessToleranceHelperText}
                                     showHelperTextAlways={item?.isValidTolerance() || isDefault}
                                     inputProps={{
                                         min: MIN_MAX.ACCESS_TOLERANCE.start,
                                         max: MIN_MAX.ACCESS_TOLERANCE.end
                                     }}
                                     placeholder={t("access_tolerance")}
                                     value={item.accessToleranceMin}
                                     trans={"access_tolerance"}
                                     onChange={(evt) => {
                                         let value = evt.target.value;
                                         if (value !== '') {
                                             value = String(Math.min(MIN_MAX.ACCESS_TOLERANCE.end, parseInt(value, 10)));
                                         }
                                         handleChange({ target: { value, name: "accessToleranceMin" } }, "accessToleranceMin");
                                     }}
                                     suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('min')}</p>}
                    />
                </Box>
                <Box className='col-12'>
                    <CustomSelectAndChildren
                        id="slc_cvif_zone_id"
                        name="zoneId"
                        value={item?.zoneId}
                        onChange={(evt) => {handleChange(evt, "zoneId")}}
                        trans="access_zone"
                        required={true}
                        emptyFields={emptyFields}
                        label="lbl_cvif_zone_id"
                        showNoSelectionOption={false}
                    >
                        {employeeWorkStations?.map((item) => (
                            <MenuItem value={item.id}>{item.name}</MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </Box>
                <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <CustomAddChipSearch
                        autocompleteId={'slt_cvif_host'}
                        buttonId={'btn_cvif_host'}
                        selectedList={selectedHost}
                        setSelectedList={setSelectedHost}
                        userTypeIdsSearch={[
                            USER_TYPE_MODEL.EMPLOYEE
                        ]}
                        disabled={requestAccessId}
                        label="host"
                        required={false}
                        reset={false}
                        hideButton={false}
                        keyId={"userId"}
                        showRenderOption={true}
                        helperText={t('host_no_required')}
                        maxLength={1}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                </Box>
                <div className={'col-12 mb-4 mt-4'}>
                    <DividerWithText title={t('validation')} />
                </div>
                <div className={"col-6"}>
                    <div className={'d-flex justify-content-start gap-46px'}>
                        <CustomSwitch
                            id='cs_cvif_documentation_validated'
                            checked={item?.documentationValidated}
                            showBorder={false}
                            trans={'require_documentation_validation'}
                            className={'fs-16px font-color-general-950 ibl-font-w-600'}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: 'documentationValidated',
                                        type: 'checkbox',
                                        checked: e.target.checked,
                                    },
                                })
                            }
                        />
                    </div>
                </div>
                {item?.documentationValidated && (
                    <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4'>
                        <CustomSelectViewCard
                            id='slt_cvif_visitor_types'
                            list={getAllVisitorTypes
                                .filter(e => e.name !== DEFAULT_VISITOR_TYPE && e.name !== NONE_VISITOR_TYPE)
                                .map(e => ({...e, name: getVisitorTypeName(t, e.name)}))}
                            value={item?.visitorType}
                            name='visitorType'
                            trans='select_visitor_type'
                            required={true}
                            onChange={(evt) => {handleChange(evt, "visitorType")}}
                            className='w-100'
                            showNoSelectionOption={false}
                            emptyFields={emptyFields}
                            disabled={disabled}

                        />
                    </Box>
                )}
                <div className={'col-12 mb-4 mt-4'}>
                    <DividerWithText title={t('visitor')} />
                </div>
                <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-5'>
                    <CustomAddChipSearch
                        id="slt_cvif_visitor"
                        buttonId={'btn_cvif_visitor'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        userTypeIdsSearch={[
                            USER_TYPE_MODEL.VISITOR
                        ]}
                        disabled={requestAccessId}
                        label="visitor"
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        hideButton={false}
                        keyId={"userId"}
                        showRenderOption={true}
                        noOptionsCard={(DEV || isGuard || permission.includes(permissionObj?.WEB_VISITOR_CREATE)) && (
                            <NotInformation
                                card={false}
                                text={t('no_visitor_search_text')}
                                showButton={true}
                                buttonId={'btn_cvf_link_create'}
                                buttonOnclick={() =>   {
                                    setAddShow(true);
                                    setModified(true);}}
                                buttonTrans={'create_a_new_visitor'}
                            />
                        )
                        }
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                </Box>
            </Box>

        </>
    )
}

export default CreateVisitorInvitationForm
